import { Modal } from "antd";
import React from "react";
import Icon from "../../assets/Icon";

function DataCapturePolicy({ dataCaptureModal, setDataCaptureModal }) {
  return (
    <Modal
      open={dataCaptureModal}
      onCancel={() => setDataCaptureModal(false)}
      footer={null}
    >
    <div className="px-3 pt-6 pb-4 text-[#475467]">
      <div className="">
        <span className="text-[#101828] font-semibold">Data Capture:</span> In the course of conducting assessments, the following data
        wil be captured
      </div>
      <div className="text-[#101828] font-semibold flex items-center gap-1 mt-[1.175rem]"><Icon type="video-logo" />Video</div>
      <div>The video feed allows for non-verbal cues assessment.</div>
      <div className="text-[#101828] font-semibold flex items-center gap-1 mt-[0.85rem]"><Icon type="audio-logo" />Audio</div>
      <div>
        Audio records spoken responses, allowing comprehensive evaluation.
      </div>
      <div className="text-[#101828] font-semibold flex items-center gap-1 mt-[0.85rem]"><Icon type="type-logo" />Type</div>
      <div>
        Text input from chat or notes taken during the assessment are stored.
      </div>
      <div className="text-[#101828] font-semibold flex items-center gap-1 mt-[0.85rem]"><Icon type="screenshare-logo" />Screen Sharing</div>
      <div>
        Screens shared during the assessment are captured for evaluation and
        review.
      </div>
      <div className="text-[#475467] font-medium mt-[1.175rem]">
        Rest assured, your data and the data of candidates are secure. We use
        advanced encryption methods and adhere to best industry practices to
        ensure data confidentiality and integrity.
      </div>
      </div>
    </Modal>
  );
}

export default DataCapturePolicy;
